import angular from 'angular';

import * as actions from '../../store/actions';

const mapStateToScope = (state) => ({});

/**
 * @ngdoc function
 * @name myConsultApp.controller:manageOnbeDowntimeWindow
 * @description
 * # manageOnbeDowntimeWindow
 * Controller of the myConsultApp
 */
angular
  .module('myConsultApp')
  .controller('manageOnbeDowntimeWindow', ($ngRedux, $rootScope, $scope, $location, $route, $http, ENV) => {
    if (!$scope.isSuperUser) {
      $location.path('/');
    }

    $scope.processParams = () =>
      new Promise((resolve) => {
        const { downtimeWindowId } = $route.current.params;
        $scope.takeAction(downtimeWindowId);
        resolve(true);
      });

    $scope.takeAction = (id) => {
      if (!id) return;

      if (id === 'create-onbe-downtime-window') {
        $scope.open(id);
      } else if (id) {
        $scope
          .getOnbeDowntimeWindow($http, ENV, id)
          .then(() => {
            $scope.open(id);
          })
          .catch(() => {
            const errorModalOptions = {
              heading: 'Onbe Downtime Window Error',
              message: `${id} is not available at this time.  It either does not exist or has caused an error.  Please try again later or contact support if the error persists.`,
              buttons: [
                {
                  label: 'Close',
                  href: '#',
                  clickFn: () => {
                    $rootScope.toggleErrorModal();
                    $location.path($rootScope.routes.onbedowntimewindow, false);
                  },
                },
              ],
            };
            $rootScope.toggleErrorModal(errorModalOptions);
          });
      }
    };

    $scope.open = (id) => {
      const component = id === 'create-onbe-downtime-window' ? 'create-onbe-downtime-window' : 'edit-onbe-downtime-window';
      const closeRoute = $rootScope.previousRoute || $rootScope.routes.onbedowntimewindow;
      const beforeRoute = `${$rootScope.routes.onbedowntimewindow}/${id}`;
      $rootScope.openComponent({
        component: component,
        beforeRoute: beforeRoute,
        closeRoute: closeRoute,
      });
    };

    $scope.init = () => {
      $rootScope.previousRoute = $rootScope.routes.onbedowntimewindow;
      $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
      $scope.processParams();
    };

    $scope.listDays = (days) => {
      var list_of_days = '';
      angular.forEach(days, function (value, key) {
        list_of_days += value + ', ';
      });
      return list_of_days.substring(0, list_of_days.length - 2);;
    }

    $scope.table = {
      name: 'Manage Onbe Downtime Windows',
      options: {
        endpoint: '/2.0/cms/onbe-downtime-windows/',
        endpoint_data_key: 'onbe-downtime-windows',
        per_page_options: [15, 25, 50, 100, 200],
        records_per_page: 15,
        row_style: 'standard',
        scale_up: false,
        search_key: null,
        search_required: false,
      },
      actions: [
        {
          name: 'Add a New Downtime Window',
          link: '#',
          onclick: () => {
            $scope.takeAction('create-onbe-downtime-window');
          },
          order: 0,
          superuser: true,
        },
      ],
      columns: [
        {
          name: 'Days Window Applies To',
          options: {
            content: '{{ listDays(record.weekday_array) }}',
            class: 'limit-width',
          },
        },
        {
          name: 'Start Time (Eastern Time)',
          options: {
            content: '{{ record.start_time_et }}',
            class: 'minimum-width',
          },
        },
        {
          name: 'End Time (Eastern Time)',
          options: {
            content: '{{ record.end_time_et }}',
            class: 'minimum-width',
          },
        },
        {
          name: 'Created',
          options: {
            content: '{{ record.created }}',
            class: '',
          },
        },
        {
          name: 'Updated',
          options: {
            content: '{{ record.updated }}',
            class: '',
          },
        },
        {
          name: 'Action',
          options: {
            content: '<a href="#" ng-click="takeAction(record.id)">Edit Downtime Window</a>',
            class: 'td-action',
          },
        },
      ],
      filters: [
        {
          name: 'Created Timeframe',
          type: 'single_choice',
          options: {
            choices: {
              'Last 24 Hours': { type: 'standard', state: false, value: 'day', order: 0 },
              'Previous Week': { type: 'standard', state: false, value: 'week', order: 1 },
              'Previous 365 Days': { type: 'standard', state: false, value: 'year', order: 2 },
              All: { type: 'standard', state: true, value: 'all', order: 3 },
              'Custom Range': {
                type: 'range',
                state: false,
                value: 'range',
                from: '',
                to: '',
                date_field: true,
                order: 4,
                error: false,
              },
            },
            class: 'timeframe-filter',
            query_string_parameter: 'created',
          },
        },
        {
          name: 'Updated Timeframe',
          type: 'single_choice',
          options: {
            choices: {
              'Last 24 Hours': { type: 'standard', state: false, value: 'day', order: 0 },
              'Previous Week': { type: 'standard', state: false, value: 'week', order: 1 },
              'Previous 365 Days': { type: 'standard', state: false, value: 'year', order: 2 },
              All: { type: 'standard', state: true, value: 'all', order: 3 },
              'Custom Range': {
                type: 'range',
                state: false,
                value: 'range',
                from: '',
                to: '',
                date_field: true,
                order: 4,
                error: false,
              },
            },
            class: 'timeframe-filter',
            query_string_parameter: 'updated',
          },
        },
      ],
      sort_options: {
        created: {
          state: false,
          value: '-1',
          title: 'Downtime Window Created',
          order: 0,
        },
        updated: {
          state: true,
          value: '-1',
          title: 'Downtime Window Updated',
          order: 1,
        },
      },
    };

    $scope.init();

    $scope.$on('$destroy', $scope.unsubscribe);
  });
